import { render, staticRenderFns } from "./prize.vue?vue&type=template&id=e42e516e&scoped=true"
import script from "./prize.vue?vue&type=script&lang=ts"
export * from "./prize.vue?vue&type=script&lang=ts"
import style0 from "./prize.vue?vue&type=style&index=0&id=e42e516e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42e516e",
  null
  
)

export default component.exports